import { type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';
import { SprachsteuerungTrigger } from './SprachsteuerungTrigger';

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den Barrel
 * eager zu laden. `SprachsteuerungTrigger` ist nur Icon + Context-Setter und
 * steht global in der TopBar, daher direkter Import (analog `NotificationsBell`).
 *
 * `enabledByDefault: false` — die Sprachbedienung ist neu und schaltet ein
 * Mikrofon ein. Das entscheidet der Betreiber bewusst über den Feature-Flag
 * `voiceControlEnabled`, nicht die Auslieferung.
 */
const manifest: SkillManifest = {
  key: 'voice-control',
  name: 'Sprachbedienung',
  description:
    'Diktat für Textfelder und globale Sprachsteuerung (Navigation, Suche, Aktionen) über die ' +
    'Spracherkennung des Browsers. Standardmäßig deaktiviert.',
  category: 'core',
  version: '0.1.0',
  enabledByDefault: false,
};

export const voiceControlSkill: FrontendSkill = {
  manifest,
  slots: {
    'global.topbar.actions': [
      {
        key: 'sprachsteuerung-trigger',
        order: 15,
        render: SprachsteuerungTrigger,
      },
    ],
  },
};
